module.exports = __webpack_public_path__ + "img/satelite.d73e60db.png";